export default __webpack_public_path__ + "static/media/SD-21.209a4e75.jpg";